<template lang="html">
  <div>

    <c-confirm-dialog v-model="dialogExclusao" @yes="excluirAcao()" titulo="Deseja realmente excluir a ação?">
      Essa ação será excluída após clicar na opção "Sim".
    </c-confirm-dialog>

    <v-toolbar color="white">

      <v-toolbar-title>Barra do administrador</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="text-xs-right">

        <c-tooltip-btn
        icon="done_outline"
        color="green"
        :disabled="projeto.situacao.item != 16"
        tooltip="Aprovar"
        disabled-tooltip='Apenas uma ação na situação "Aguardando aprovação" pode ser aprovada'
        @click="goAprovarProjeto()"
        ></c-tooltip-btn>

        <c-tooltip-btn
        icon="not_interested"
        color="red"
        :disabled="projeto.situacao.item != 16"
        tooltip="Devolver para o coordenador"
        disabled-tooltip='Apenas uma ação na situação "Aguardando aprovação" pode ser devolvida para o coordenador'
        @click="goDevolverProjeto()"
        ></c-tooltip-btn>

        <!-- Liberar preenchimento do relatório técnico final -->
        <div v-if="projeto.situacao.item === 15 && projeto.registroTardio === true">
          <c-tooltip-btn
          icon="post_add"
          color="primary"
          :disabled="projeto.relatorioFinalHabilitado === true"
          tooltip="Liberar preenchimento do relatório técnico final"
          disabled-tooltip='O preenchimento do relatório técnico final já foi liberado'
          @click="goLiberarRelatorio()"
          ></c-tooltip-btn>
        </div>

        <c-tooltip-btn
        icon="autorenew"
        color="primary"
        :disabled="projeto.situacao.item != 20"
        tooltip="Desfazer Finalização (A ação volta a ficar ativa)"
        disabled-tooltip='Apenas uma ação na situação "Aguardando relatório" pode ter sua finalização desfeita'
        @click="goDesfazerFinalizacao()"
        ></c-tooltip-btn>

        <!-- Suspender / Prorrogar suspensão -->
        <c-tooltip-btn
        icon="pause_circle"
        color="primary"
        :disabled="projeto.situacao.item != 18 && projeto.situacao.item != 4 && projeto.situacao.item != 3"
        :tooltip="(projeto.situacao.item === 18 || projeto.situacao.item === 3) ? 'Suspender' : 'Prorrogar suspensão'"
        disabled-tooltip='Para ser suspensa, a ação de extensão deve estar na situação "Ativo" ou "Inadimplente". Para prorrogar a suspensão, a ação de extensão deve estar na situação "Suspenso"'
        @click="goSuspenderAcaoExtensao()"
        ></c-tooltip-btn>

        <!-- Reativar -->
        <c-tooltip-btn
        icon="play_circle"
        color="primary"
        :disabled="projeto.situacao.item != 4 && projeto.situacao.item != 3"
        tooltip="Reativar"
        disabled-tooltip='Para ser reativada, a ação de extensão deve estar na situação "Suspenso" ou "Inadimplente"'
        @click="goReativarAcaoExtensao()"
        ></c-tooltip-btn>

        <!-- Concluir -->
        <c-tooltip-btn
        icon="folder"
        color="brown lighten-1"
        :disabled="projeto.situacao.item != 20 && projeto.situacao.item != 4 && projeto.situacao.item != 3"
        tooltip="Concluir"
        disabled-tooltip='Apenas uma ação na situação "Suspenso", "Inadimplente" ou "Aguardando envio de relatório" pode ser concluída'
        @click="goConcluirProjeto()"
        ></c-tooltip-btn>

        <!-- Cancelar -->
        <c-tooltip-btn
        icon="cancel_presentation"
        color="red"
        :disabled="projeto.situacao.item != 18 && projeto.situacao.item != 20 && projeto.situacao.item != 4 && projeto.situacao.item != 3"
        tooltip="Cancelar"
        disabled-tooltip='Apenas uma ação na situação "Ativo", "Inadimplente", "Suspenso" ou "Aguardando envio de relatório" pode ser cancelada'
        @click="goCancelarProjeto()"
        ></c-tooltip-btn>

        <c-tooltip-btn
        icon="cancel"
        color="black"
        :disabled="projeto.situacao.item != 16"
        tooltip="Inabilitar"
        disabled-tooltip='Apenas uma ação na situação "Aguardando aprovação" pode ser inabilitada'
        @click="goInabilitarProjeto()"
        ></c-tooltip-btn>

        <c-tooltip-btn
        icon="mode"
        color="primary"
        :disabled="projeto.situacao.item != 18 && projeto.situacao.item != 15"
        tooltip="Alterar classificação secundária"
        disabled-tooltip='A ação de extensão deve estar na situação "Ativo" ou "Preenchimento incompleto" para ter sua classificação secundária alterada'
        @click="goAlterarClassificacaoSecundaria()"
        ></c-tooltip-btn>

        <c-tooltip-btn v-if="projeto.situacao.item != 21"
        icon="delete"
        color="primary"
        :disabled="projeto.situacao.item != 15 && projeto.situacao.item != 16"
        tooltip="Excluir ação"
        disabled-tooltip='Apenas uma ação na situação "Preenchimento incompleto" ou "Aguardando aprovação" pode ser excluída'
        @click="botaoExcluirAcao()"
        ></c-tooltip-btn>

        <c-tooltip-btn v-else
        icon="restore_from_trash"
        color="primary"
        tooltip="Desfazer Exclusão"
        @click="goDesfazerExclusao()"
        ></c-tooltip-btn>
      </v-toolbar-items>
    </v-toolbar>


  </div>
</template>

<script>
  import ConfirmDialog from '@/components/c-confirm-dialog'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['projeto', 'extensao'],
    data: () => ({
      dialogExclusao: false,
      dialogFinalizar: false,
      data: '',
      dataFormatada: '',
      menuData: false
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      goAprovarProjeto () {
        this.$router.push({name: 'AprovarProjeto', params: {idProjeto: this.projeto.idProjeto}})
      },
      goDevolverProjeto () {
        this.$router.push({name: 'DevolverProjeto', params: {idProjeto: this.projeto.idProjeto}})
      },
      goLiberarRelatorio () {
        this.$router.push({name: 'LiberarRelatorio', params: {idProjeto: this.projeto.idProjeto}})
      },
      goInabilitarProjeto () {
        this.$router.push({name: 'InabilitarProjeto', params: {idProjeto: this.projeto.idProjeto}})
      },
      goSuspenderAcaoExtensao () {
        this.$router.push({name: 'SuspenderAcaoExtensao', params: {idProjeto: this.projeto.idProjeto}})
      },
      goReativarAcaoExtensao () {
        this.$router.push({name: 'ReativarAcaoExtensao', params: {idProjeto: this.projeto.idProjeto}})
      },
      goAlterarClassificacaoSecundaria () {
        this.$router.push({name: 'AlterarClassificacaoSecundaria', params: {idProjeto: this.projeto.idProjeto}})
      },
      goConcluirProjeto () {
        this.$router.push({name: 'ConcluirProjeto', params: {idProjeto: this.projeto.idProjeto}})
      },
      goCancelarProjeto () {
        this.$router.push({name: 'CancelarProjeto', params: {idProjeto: this.projeto.idProjeto}})
      },
      goDesfazerExclusao () {
        this.$router.push({name: 'DesfazerExclusao', params: {idProjeto: this.projeto.idProjeto}})
      },
      goDesfazerFinalizacao () {
        this.$router.push({name: 'DesfazerFinalizacao', params: {idProjeto: this.projeto.idProjeto}})
      },
      botaoFinalizarAcao: function () {
        this.dialogFinalizar = true
      },
      finalizarAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação...' })
        projetos.postSubmissaoConclusao(this.projeto.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          window.location.reload()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação...' })
        })
      },
      botaoExcluirAcao: function () {
        this.dialogExclusao = true
      },
      excluirAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        projetos.deleteProjeto(this.projeto.idProjeto)
        .then(response => {
          this.$router.push({ name: 'MeusProjetos' })
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        })
      },
      renovarAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        projetos.deleteProjeto(this.projeto.idProjeto)
        .then(response => {
          this.$router.push({ name: 'MeusProjetos' })
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo ação...' })
        })
      },
      concluirAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação...' })
        projetos.postConcluirProjeto(this.projeto.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo ação...' })
        })
      },
      cancelarAcao: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação...' })
        projetos.postCancelarProjeto(this.projeto.idProjeto)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando ação...' })
        })
      },
      toRelatorio: function () {
        this.$router.push({ name: 'Relatorio', params: {idProjeto: this.projeto.idProjeto} })
      },
      toEditar: function () {
        this.$router.push({ name: this.editar, params: {idProjeto: this.projeto.idProjeto} })
      },
      toAvancar: function () {
        this.$router.push({ name: this.proxima, params: {idProjeto: this.projeto.idProjeto} })
      }
    },
    components: {
      'c-confirm-dialog': ConfirmDialog,
      'c-tooltip-btn': TootipButton
    }
  }
</script>



// WEBPACK FOOTER //
// c-barra-administrador.vue?0d99078a